import { render, staticRenderFns } from "./cart-btn.app.vue?vue&type=template&id=4bc940ea&"
import script from "./cart-btn.app.vue?vue&type=script&lang=js&"
export * from "./cart-btn.app.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports